import { useState } from "react";
import { useAuth } from "react-oidc-context";

import { Divider, List, ListItem, ListItemButton, Popover, Stack, Typography } from "@mui/material";
import { accordionStorage } from "@shared";

import { UserSettingsDialog } from "@/common/components/user-settings-dialog/UserSettingsDialog";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { useTranslation } from "@/translations";

import { UserDropdownAvatar } from "./components/user-dropdown-avatar/UserDropdownAvatar";

export default function UserDropdown() {
  const { currentUser } = useCurrentUserContext();
  const auth = useAuth();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isUserSettingsOpen, setIsUserSettingsOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserSettings = () => {
    handleClose();
    setIsUserSettingsOpen(true);
  };

  const handleLogout = () => {
    handleClose();
    accordionStorage.clear();
    void auth.signoutRedirect();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <Stack>
      <UserDropdownAvatar onClick={handleClick} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <Typography>{currentUser.name}</Typography>
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={handleUserSettings}>
              <Typography>{t("layout.header.userSettings")}</Typography>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <Typography>{t("auth.logout")}</Typography>
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      {isUserSettingsOpen && <UserSettingsDialog onClose={() => setIsUserSettingsOpen(false)} />}
    </Stack>
  );
}
